import { render } from "./SkillsCategory.vue?vue&type=template&id=7b03b8d6&scoped=true"
import script from "./SkillsCategory.vue?vue&type=script&lang=js"
export * from "./SkillsCategory.vue?vue&type=script&lang=js"

import "./SkillsCategory.vue?vue&type=style&index=0&id=7b03b8d6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b03b8d6"]])

export default __exports__